import classNames from 'classnames';
import React from 'react';
import { Popover, Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { Panel } from './panel';
import { type Props } from './types';
import './style.less';

export const ListStyleSelector: React.FC<Props> = (props) => {
    const { $t } = useLocaleStore();

    const { disabled, onOpenChange, ...baseProps } = props;

    return (
        <Popover
            trigger="click"
            placement="bottom"
            overlayClassName="list-style-selector"
            destroyTooltipOnHide
            showArrow={false}
            onOpenChange={onOpenChange}
            content={<Panel {...baseProps} />}
        >
            <Tooltip placement="bottom" title={$t((v) => v.textAttr.listFormat)}>
                <div
                    className={classNames('list-style-selector__button', {
                        disabled,
                    })}
                    onClickCapture={(event) => {
                        if (disabled) return event.stopPropagation();
                    }}
                >
                    <IconFont name="TextListBold" fontSize={16} />
                    <IconFont
                        className="list-style-selector__icon-arrow"
                        name="ChevronDownBlack"
                        fontSize={12}
                        color="var(--content-input-lable)"
                    />
                </div>
            </Tooltip>
        </Popover>
    );
};
